<template>
    <div>
        <div class="card shadow-sm">
            <div class="card-body">
                <h3 class="card-title mb-4">
                    {{ $t('actions.edit') }}:
                    {{
                        isInvoice ?
                            $t('pages.subscription.start.address.invoice_address') :
                            $t('pages.subscription.start.address.delivery_address')
                    }}
                </h3>

                <static-loading-indicator-icon :loading="$store.getters.shouldLoadLocal"/>

                <form v-if="!$store.getters.shouldLoadLocal" @submit.prevent="updateAddress">
                    <div class="alert alert-danger shadow-sm" v-html="$t('pages.subscription.start.address.delivery_add_lux_only')" v-if="isDelivery"></div>

                    <address-form v-bind:value="address" @input="address = $event" validation-name-prefix="" v-if="address !== null" :lux-only="isDelivery"/>

                    <button class="btn btn-outline-dark" >
                        {{ $t('actions.update') }}
                    </button>

                    <router-link tag="button" class="btn btn-outline-secondary ml-3" :to="{name: 'account.address'}">
                        {{ $t('actions.cancel') }}
                    </router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import AddressForm from "../../../Subscription/Start/Includes/AddressForm";
import AccountRepository from "../../../../repositories/Account/AccountRepository";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";
export default {
    name: "AddressEdit",
    components: {StaticLoadingIndicatorIcon, AddressForm},
    data: () => ({
        address: null,
    }),
    mounted() {
        this.getAddress();
    },
    methods: {
        getAddress() {
            AccountRepository
                .getAddress(this.type)
                .then((res) => {
                    this.address = res.data;
                })
        },
        updateAddress() {
            AccountRepository.updateAddress(this.address.id, {
                full_name: this.address.full_name,
                address_one: this.address.address_one,
                address_two: this.address.address_two,
                city: this.address.city,
                postal_code: this.address.postal_code,
                country_id: this.address.country_id,
            }).then((res) => {
                this.$snotify.success(this.$t('actions.updated'));
                this.$router.push({name: 'account.address'});
            })
        }
    },
    computed: {
        isInvoice() {
            return this.type === 'invoice';
        },
        isDelivery() {
            return this.type === 'delivery';
        },
        type() {
            return this.$route.params.type;
        }
    }
}
</script>

<style scoped>

</style>
